import React from 'react'

interface InternalBlockIconProps {
  color?: string
  width?: number
  height?: number
  alt?: string
}

const InternalBlockIcon: React.FC<InternalBlockIconProps> = ({
  color = '#000',
  width = 48,
  height = 48,
  alt = 'Internal block icon',
}) => {
  const maskId = `InternalBlockMask-${React.useId()}`

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 48 48'
      aria-label={alt}
    >
      <title>{alt}</title>
      <mask
        id={maskId}
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='48'
        height='48'
      >
        <rect width='48' height='48' fill={color} />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d='M38 6C39.1 6 40.0419 6.39147 40.8252 7.1748C41.6085 7.95814 42 8.9 42 10V29.668C40.9166 29.2383 39.7363 29 38.5 29C33.2533 29 29 33.2533 29 38.5C29 39.7363 29.2383 40.9166 29.668 42H10C8.9 42 7.95814 41.6085 7.1748 40.8252C6.39147 40.0419 6 39.1 6 38V10C6 8.9 6.39147 7.95814 7.1748 7.1748C7.95814 6.39147 8.9 6 10 6H38ZM16 30C15.4333 30 14.9585 30.1919 14.5752 30.5752C14.1919 30.9585 14 31.4333 14 32C14 32.5667 14.1919 33.0415 14.5752 33.4248C14.9585 33.8081 15.4333 34 16 34H26C26.5667 34 27.0415 33.8081 27.4248 33.4248C27.8081 33.0415 28 32.5667 28 32C28 31.4333 27.8081 30.9585 27.4248 30.5752C27.0415 30.1919 26.5667 30 26 30H16ZM16 22C15.4333 22 14.9585 22.1919 14.5752 22.5752C14.1919 22.9585 14 23.4333 14 24C14 24.5667 14.1919 25.0415 14.5752 25.4248C14.9585 25.8081 15.4333 26 16 26H32C32.5667 26 33.0415 25.8081 33.4248 25.4248C33.8081 25.0415 34 24.5667 34 24C34 23.4333 33.8081 22.9585 33.4248 22.5752C33.0415 22.1919 32.5667 22 32 22H16ZM16 14C15.4333 14 14.9585 14.1919 14.5752 14.5752C14.1919 14.9585 14 15.4333 14 16C14 16.5667 14.1919 17.0415 14.5752 17.4248C14.9585 17.8081 15.4333 18 16 18H32C32.5667 18 33.0415 17.8081 33.4248 17.4248C33.8081 17.0415 34 16.5667 34 16C34 15.4333 33.8081 14.9585 33.4248 14.5752C33.0415 14.1919 32.5667 14 32 14H16Z'
          fill={color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38.585 32.092C38.9188 31.872 39.3517 31.872 39.6855 32.092L41.54 33.3146C41.8204 33.4997 41.9893 33.8136 41.9893 34.1496V35.297H45.2705C45.8225 35.2973 46.2704 35.745 46.2705 36.297V45.0002C46.2704 45.5522 45.8225 45.9999 45.2705 46.0002H33C32.4478 46.0002 32.0001 45.5523 32 45.0002V36.297C32.0001 35.7449 32.4478 35.297 33 35.297H36.2812V34.1496C36.2812 33.8135 36.45 33.4997 36.7305 33.3146L38.585 32.092ZM37.708 45.9992H39.1348V41.7179H37.708V45.9992ZM39.1357 45.9992H40.5625V41.7179H39.1357V45.9992ZM33.4268 43.8595H34.8535V42.4328H33.4268V43.8595ZM43.417 42.4328V43.8595H44.8438V42.4328H43.417ZM33.4268 41.005H34.8535V39.5783H33.4268V41.005ZM43.417 41.005H44.8438V39.5783H43.417V41.005ZM33.4268 38.1515H34.8535V36.7238H33.4268V38.1515ZM43.417 38.1515H44.8438V36.7238H43.417V38.1515ZM39.1348 36.0099C38.5438 36.0099 38.0647 36.4893 38.0645 37.0802C38.0645 37.6713 38.5437 38.1505 39.1348 38.1505C39.7257 38.1504 40.2051 37.6712 40.2051 37.0802C40.2048 36.4894 39.7256 36.0101 39.1348 36.0099Z'
          fill={color}
        />
      </g>
    </svg>
  )
}

export default InternalBlockIcon
